// Mock data for Square Darts Brasil site
export const CATEGORIES = [
  {
    id: '01',
    title: 'ESTABELECIMENTOS',
    description: 'Solução completa para bares, pubs e salões de jogos: alvo eletrónico, ecrã de jogo e tablet de controlo integrados.',
    image: 'https://customer-assets-wrfwihn1.emergentagent.net/job_darts-responsive/artifacts/66gmx9jt_SITE%20.webp'
  },
  {
    id: '02',
    title: 'CONEXÃO GLOBAL',
    description: 'Rede unificada que interliga jogadores em todo o território nacional e para o resto do mundo.',
    image: 'https://images.unsplash.com/photo-1594492691731-3d7974140624?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwzfHxuZXR3b3JrJTIwZ2xvYmV8ZW58MHx8fGJsdWV8MTc4OTY1NjY3Nnww&ixlib=rb-4.1.0&q=85'
  },
  {
    id: '03',
    title: 'PAGAMENTO SEGURO',
    description: 'Terminal integrado com pagamento contactless, seguro e certificado. Compatível com SumUp Solo e sistemas equivalentes.',
    image: 'https://images.ctfassets.net/txhaodyqr481/4BEVfOiuKRGsYNvD3wNI8t/11bba94c28f5b89dba4ade48069db788/Hero1-Desktop.png?fm=avif&q=85&w=618&h=618'
  },
  {
    id: '04',
    title: 'COMPETIÇÕES NACIONAIS E INTERNACIONAIS',
    description: 'Apuramentos para torneios locais, nacionais e mundiais com prêmios reais.',
    image: 'https://images.unsplash.com/photo-1578269174936-2709b6aeb913?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwxfHx0cm9waHklMjBjaGFtcGlvbnNoaXB8ZW58MHx8fHwxNzg5NjU2NjY2fDA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: '05',
    title: 'APP DO JOGADOR',
    description: 'Estatísticas, ranking, histórico de partidas e inscrição em torneios em um só lugar.',
    image: 'https://customer-assets-wrfwihn1.emergentagent.net/job_darts-responsive/artifacts/pfmelt4v_APP.webp'
  },
  {
    id: '06',
    title: 'SISTEMA ANTIBATOTA',
    description: 'Tecnologia proprietária de detecção de fraudes para garantir competições justas.',
    image: 'https://customer-assets-wrfwihn1.emergentagent.net/job_darts-responsive/artifacts/wepihuzh_001.jpg'
  },
  {
    id: '07',
    title: 'FORMAS DE PAGAMENTO',
    description: 'Na Square Darts poderás pagar por PIX ou Cartão de Débito/Crédito para jogar as tuas partidas. Paga por partida ou por tempo — 5m, 15m, 30m ou 1 hora — ou compra tempo diretamente no balcão do bar. Alguns bares poderão oferecer packs de bebidas e comida + dardos para uma noite de qualidade com amigos. E se quiseres competir a sério, acede a torneios exclusivos com SQUARE DARTS PREMIUM.',
    image: 'https://customer-assets-wrfwihn1.emergentagent.net/job_darts-responsive/artifacts/w49p8lxl_SITE%20.webp',
    featured: true
  }
];

export const MISSION_BLOCKS = [
  {
    id: 1,
    title: 'APURMAMENTOS PARA COMPETIÇÕES INTERNACIONAIS',
    items: ['EUROPA', 'ASIA', 'AMERICA'],
    tag: '+ COMPETIÇÃO'
  },
  {
    id: 2,
    title: 'APURAMENTOS PARA NACIONAIS',
    items: ['CAMPEONATO NACIONAL DE DARDOS BRASIL'],
    subtitle: 'APURAMENTO PARA EVENTOS LOCAIS',
    subitems: ['INTERBARES', 'INTERCIDADES']
  },
  {
    id: 3,
    title: 'COMPETIÇÕES MENSAIS COM PRÉMIOS',
    description: 'Torneios recorrentes em toda a rede Square Darts, com prêmios em dinheiro, equipamento e vagas para os campeonatos maiores.'
  },
  {
    id: 4,
    title: 'ALAVANCAR OS JOGADORES DE DARDOS NO BRASIL COM PATROCÍNIOS E ATRAIR + JOVENS PARA O DESPORTO DOS DARDOS',
    description: 'Programa de patrocínios para jogadores promissores e ações de divulgação em escolas, universidades e clubes.'
  }
];

export const HERO_IMAGE = 'https://customer-assets-wrfwihn1.emergentagent.net/job_darts-responsive/artifacts/vz334565_ALVO.webp';
export const GLOBE_IMAGE = 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&q=80&w=1200';
